import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, Type} from "@angular/core";
import {ConfigurationService, EntityData, EntityService, ResourceModule} from "@fedeltapointofsale/data-client";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";
import {EditRoute} from "../../../../main/main.routing";
import {EditParams} from "../edit-page/edit-params";
import {EditMode} from "../edit-page/edit-mode";
import {ErrorHandlerService} from "../../../../error-handler.service";
import {RoutingDiscoveryService} from "../../../../routing-discovery.service";
import {Subscription} from "rxjs";
import {AnalyticsService} from "../../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../../analytics/analytic-event";
import {EditService} from "../edit-page/edit.service";

@Component({
    selector: "wbo-edit-link",
    styleUrls: ["./edit-link.component.scss"],
    templateUrl: "./edit-link.component.html"
})
export class EditLinkComponent implements OnInit, OnDestroy {
    @Input() dataItem: EntityData<any>;
    @Input() field: string;
    @Input() componentPath: string;
    @Input() editComponent: Type<any>;
    @Input() editPath: string;
    @Input() editParams: any;
    @Input() parentEntity: any;
    @Input() editMode: EditMode;

    @Output() onSave: EventEmitter<EntityData<any>> = new EventEmitter<EntityData<any>>();

    private subscriptions: Subscription = new Subscription();

    private openingLink: boolean;

    constructor(private stackedPageService: FUIStackedPageService,
                private errorHandlerService: ErrorHandlerService,
                private configService: ConfigurationService,
                private editService: EditService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) private nameSpace: string,
                private routingDiscoveryService: RoutingDiscoveryService,
                private analyticsService: AnalyticsService) {
    }

    ngOnInit(): void {
        if (this.editPath && !this.editComponent) {
            this.editComponent = this.routingDiscoveryService.findRoutingComponent(this.editPath);
        }
        if (this.editMode === undefined) {
            this.editMode = this.editService && this.editService.editMode === EditMode.EDIT ? EditMode.EDIT : EditMode.VIEW;
        }
    }

    public openEditLink(event: Event): void {
        if (this.openingLink) {
            return;
        }
        this.openingLink = true;

        event.cancelBubble = true;
        const editEntity: EntityData<any> = EntityData.getField(this.dataItem, this.componentPath);
        const component: Type<any> = this.editComponent ? this.editComponent :
            this.routingDiscoveryService.findRoutingComponent(editEntity.constructor.name
                .replace(/Data$/, "")
                .replace(/Reference$/, "")
                .replace(/^([A-Z])/g, (match) => match.toLowerCase())
                .replace(/([A-Z])/g, (match) => "-" + match.toLowerCase()));
        if (component) {
            const route: EditRoute = this.routingDiscoveryService.findComponentRoute(component);
            if (route) {
                const nameSpace: string = route.nameSpace || this.nameSpace;
                EntityService.canGetEntity(this.configService, nameSpace + "/" + (route.entity ? route.entity : route.editPath))
                    .then(available => {
                        if (available) {
                            this.subscriptions.add(this.stackedPageService.open(component, new EditParams(editEntity.getIdentifier(), this.editMode, this.parentEntity, this.editParams))
                                .subscribe((entity: EntityData<any>) => {
                                    this.onSave.next(entity);
                                }, () => {
                                }, () => {
                                    this.openingLink = false
                                }));

                            this.analyticsService.trackEvent(AnalyticEvent.ENTITY_INTERACTION_GRID_VIEW, (route.entity ? route.entity : route.editPath));
                        } else {
                            this.openingLink = false;
                            this.errorHandlerService.displayError("wbo.edit.error.cannotView");
                            this.analyticsService.trackEvent(AnalyticEvent.ENTITY_INTERACTION_GRID_VIEW_NO_PRIV, (route.entity ? route.entity : route.editPath));
                        }
                    })
            } else {
                this.subscriptions.add(this.stackedPageService.open(component, new EditParams(editEntity.getIdentifier(), this.editMode, this.parentEntity, this.editParams))
                    .subscribe((entity: EntityData<any>) => {
                        this.onSave.next(entity);
                    }, () => {
                    }, () => {
                        this.openingLink = false
                    }));
            }
        } else {
            this.openingLink = false;
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
